import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'

import { store } from './store';
import router from './router.js';
import authService from './services/authService';
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false

Vue.use(VueRouter);

new Vue({
  render: h => h(App),
  store,
  router,
  vuetify,

  beforeCreate () {
    authService.status();
  }
}).$mount('#app')
